import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Link } from 'react-router-dom'

interface HeaderProps {
  bgColor?: 'light' | 'dark' | 'gray'
  variant?: 'default' | 'condensed'
}

export const Header = styled.header<HeaderProps>`
  background-color: ${props => (props.bgColor === 'light' ? '#fff' : '#fafafa')};
  padding: 8px 16px 8px 50px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-family: 'Noto Sans', sans-serif;
  z-index: 100;

  ${props =>
    props.variant === 'default' &&
    css`
      padding-left: 50px;
    `}

  ${props =>
    props.variant === 'condensed' &&
    css`
      padding-left: 30px;
    `}
`

export const Icons = styled.div`
  display: flex;
  margin-right: 6px;

  > * {
    margin-left: 2px;
  }
`

export const ProfileMenu = styled.nav``

export const Breadcrumbs = styled.nav`
  margin-right: auto;
  display: flex;
`

export const BreadcrumbNoLink = styled.a`
  color: #9e9e9e;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
`

export const BreadcrumbLink = styled(Link)`
  color: #9e9e9e;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  transition: all 250ms ease-in-out;
  border-bottom: 1px solid transparent;

  &:hover {
    color: #777;
    border-bottom: 1px solid #9e9e9e;
  }
`

export const BreadcrumbDivider = styled.span`
  color: #5dd39e;
  font-size: 12px;
  padding: 0 5px;
  display: inline-flex;
  align-items: center;
`
